(() => {
  if (window.__hmMainProductUrlSyncInitialized) {
    return;
  }
  window.__hmMainProductUrlSyncInitialized = true;

  const getUrlVariantParam = (variant) => {
    if (!variant) return "";
    return (
      variant.url_variant_param ||
      (typeof variant.sku === "string" ? variant.sku.trim() : "") ||
      String(variant.id || "")
    );
  };

  const syncUrlToVariant = (variant) => {
    if (!window.history?.replaceState) return;
    if (!document.querySelector("variant-picker[data-hm-update-url]")) return;

    const variantParam = getUrlVariantParam(variant);
    if (!variantParam) return;

    const url = new URL(window.location.href);
    url.searchParams.set("id", variantParam);
    url.searchParams.delete("option_values");
    window.history.replaceState({ path: url.toString() }, "", url.toString());
  };

  const getOemCartMap = (productForm) => {
    const el = productForm?.querySelector("[data-hm-oem-cart-variants]");
    if (!el) {
      return {};
    }

    try {
      return JSON.parse(el.textContent || "{}");
    } catch (_error) {
      return {};
    }
  };

  const syncHmOemCartUi = (variant) => {
    document.querySelectorAll(".product-form").forEach((productForm) => {
      const variantId =
        variant?.id ??
        productForm.querySelector('input[name="id"]')?.value ??
        "";
      const status =
        productForm
          .querySelector("product-payment-container[data-hm-sale-status]")
          ?.getAttribute("data-hm-sale-status") ?? "";
      const oemCartMap = getOemCartMap(productForm);
      const hasOemCart =
        status === "oem_cart" ||
        (variantId !== "" && oemCartMap[String(variantId)] === true);

      productForm.classList.toggle("is-oem-cart", hasOemCart);
    });
  };

  const syncHmRestockUi = () => {
    const productForm = document.querySelector(".product-form");
    if (!productForm) {
      return;
    }

    const status =
      productForm
        .querySelector("product-payment-container[data-hm-sale-status]")
        ?.getAttribute("data-hm-sale-status") ?? "";

    productForm.querySelectorAll(".restock-rocket-button-container").forEach((el) => {
      el.style.display = status === "stock_out_notify" ? "" : "none";
    });

    const buyButtons = productForm.querySelector(".product-form__buy-buttons");
    if (buyButtons) {
      buyButtons.style.display = status === "stock_out_notify" ? "none" : "";
    }
  };

  const observeRestockRocket = () => {
    const productForm = document.querySelector(".product-form");
    if (!productForm || productForm.dataset.hmRestockObserver === "true") {
      return;
    }

    productForm.dataset.hmRestockObserver = "true";
    const observer = new MutationObserver(() => {
      syncHmOemCartUi();
      syncHmRestockUi();
    });
    observer.observe(productForm, { childList: true, subtree: true });
  };

  document.addEventListener("variant:changed", (event) => {
    const variant = event?.detail?.variant;

    syncUrlToVariant(variant);
    syncHmOemCartUi(variant);
    window.setTimeout(syncHmRestockUi, 0);
    window.setTimeout(() => syncHmOemCartUi(variant), 0);
  });

  document.addEventListener("product:rerender", () => {
    window.setTimeout(syncHmRestockUi, 0);
    window.setTimeout(() => syncHmOemCartUi(), 0);
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
      syncHmOemCartUi();
      syncHmRestockUi();
      observeRestockRocket();
    });
  } else {
    syncHmOemCartUi();
    syncHmRestockUi();
    observeRestockRocket();
  }
})();
